<template>
  <div>
    <b-alert variant="danger" :show="!!items.error"> {{ items.error }} </b-alert>
    <loader :is-loading="loading">
      <div v-if="!loading && !items.error">
        <slot name="filters" />
        <b-pagination
          v-if="items.totalPages > 1"
          v-model="page"
          :total-rows="items.totalCount"
          :per-page="perPage"
          :max-size="items.totalPages"
          size="sm"
          align="right"
          hide-goto-end-buttons
        />
        <slot name="items" />
        <b-pagination
          v-if="items.totalPages > 1"
          v-model="page"
          class="mt-4"
          :total-rows="items.totalCount"
          :per-page="perPage"
          size="sm"
          align="right"
          hide-goto-end-buttons
        />
      </div>
    </loader>
  </div>
</template>

<script>
export default {
  props: ['items', 'setPageCallback', 'loading', 'perPage'],
  computed: {
    top() {
      let element = this.$el;
      let top = 0;
      do {
        top += element.offsetTop || 0;
        element = element.offsetParent;
      } while (element);
      return top;
    },
    page: {
      get() {
        return this.items.currentPage;
      },
      set(newValue) {
        this.setPageCallback(newValue);

        window.scrollTo(0, this.top);
      }
    }
  }
};
</script>
